import { render, staticRenderFns } from "./WebSocketManager.vue?vue&type=template&id=4154a160&"
import script from "./WebSocketManager.vue?vue&type=script&lang=js&"
export * from "./WebSocketManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports